import { ElectronicTradingContainer } from '../../containers/advancedFilters/ElectronicTradingContainer';
import { IFilter } from '../../types/advancedFilters';

export const electronicTrading: IFilter = {
  component: ElectronicTradingContainer,
};
